<template>
	<v-card>
		<v-card-title style="display: block;">
			<div class="d-flex">
				<span class="headline">مدیریت مدارک</span>
				<v-spacer />
				<v-btn @click="$emit('close')" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>
			<div class="d-flex align-center px-7" v-if="loan">
				<div class="pt-5 pr-5 pl-8">
					<v-checkbox class="small" color="secondary" @change="checkboxAllChanged" label="انتخاب همه" />
				</div>
				<div class="pt-2">
					فیلتر:
				</div>
				<v-radio-group v-model="filter" hide-details row>
					<v-radio class="small rtl" label="همه مدارک سیستم" color="secondary" :value="'all'"></v-radio>
					<v-radio class="small rtl" :label="`مرتبط با ${loan.title}`" color="secondary" :value="'loan'"></v-radio>
				</v-radio-group>
			</div>
		</v-card-title>
		<v-card-text>
			<v-container>
				<div>
					<div v-if="loading">
						<div class="success--text text-h4 text-center">
							در حال دریافت اطلاعات...
						</div>
					</div>
					<div v-else>
						<div v-if="!items.length">
							<h3 class="text-center red--text">تاکنون مدرکی در سیستم ثبت نشده است</h3>
							<div class="text-center mt-5">
								<v-btn class="mx-auto" color="secondary" dark @click="add">
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									افزودن مدرک
								</v-btn>
							</div>
						</div>
						<div v-else>
							<v-card v-for="(item, index) in filteredItems" :key="item.id + index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
								<v-row>
									<v-col cols="1">
										<v-checkbox color="secondary" v-model="selectedItemIds" @change="(val) => checkboxChanged(val, item)" label="" :disabled="item.id === emptyId" :value="item.id" />
									</v-col>
									<v-col cols="11">
										<v-row class="ma-0 pa-0">
											<v-col cols="12" md="7" class="py-0 my-0">
												<v-text-field :disabled="!item.editMode" v-model="item.title" label="عنوان مدرک*" :error-messages="errorMessages" :rules="[(val) => !!val || 'عنوان مدرک را وارد کنید']" required />
											</v-col>
											<v-col cols="12" md="5" class="my-0 py-0">
												<v-combobox :disabled="!item.editMode" v-model="item.systemType" required :items="systemTypes" label="معادل سیستمی*" single-line return-object item-text="title" item-value="id" />
											</v-col>
										</v-row>
										<v-row class="ma-0 pa-0" v-if="!isModuleActive(item.systemType)">
											<v-col cols="12" class="my-0 py-0">
												<v-alert outlined type="warning">این ماژول برای شما فعال نمی
													باشد</v-alert>
											</v-col>
										</v-row>
										<v-row class="ma-0 pa-0" v-else>
											<v-col cols="12" class="my-0 py-0" v-if="item.systemType && item.systemType.id != 0">
												<v-checkbox :disabled="!item.editMode" color="secondary" v-model="item.useIfAlreadyExist" :label="'در صورتیکه مشتری قبلا این نوع مدرک را در وام های دیگر به صورت تایید شده داشته باشد، از همان به عنوان مرجع استفاده شود.'" />
											</v-col>
											<v-col cols="10" class="my-0 py-0" v-if="item.systemType && [5, 7].includes(item.systemType.id)">
												<div v-if="item.editMode">
													<label class="">تگ های سیستمی: <small>(با درج تگ های سیستمی به
															توضیحات قرارداد، اطلاعات به صورت خودکار جایگزین می شود)
														</small></label>
													<ul class="pattern-tags mb-5">
														<li v-for="tag in patternTags(item.systemType.id)" :key="tag" @click="appendTag(tag, index)">
															{{ tag }}
														</li>
														<li @click="showManualTag(index)" class="info--text">
															افزودن تگ دستی
														</li>
													</ul>
													<label class="">توضیحات قرارداد:</label>
													<ckeditor :editor="editor" :ref="'ckeditor' + index" :disabled="!item.editMode" v-model="item.description" :config="editorConfig" @ready="(edt) => onEditorReady(edt, index)"></ckeditor>
												</div>
											</v-col>
											<v-col cols="10" class="my-0 py-0" v-if="item.systemType && [6].includes(item.systemType.id)">
												<div v-if="item.editMode">
													<label class="">تگ های سیستمی: <small>(با درج تگ های سیستمی به
															توضیحات قرارداد، اطلاعات به صورت خودکار جایگزین می شود)
														</small></label>
													<ul class="pattern-tags mb-5">
														<li v-for="tag in patternTags(item.systemType.id)" :key="tag" @click="appendTag(tag, index)">
															{{ tag }}
														</li>
													</ul>
													<label class="">توضیحات قرارداد:</label>
													<ckeditor :editor="editor" :ref="'ckeditor' + index" :disabled="!item.editMode" v-model="item.description" :config="editorConfig" @ready="(edt) => onEditorReady(edt, index)"></ckeditor>
												</div>
											</v-col>
											<v-col cols="10" class="my-0 py-0" v-else>
												<v-textarea :disabled="!item.editMode" rows="2" v-model="item.description" outlined :error-messages="errorMessages" label="توضیحات" hint="حداکثر 1000 کاراکتر" placeholder="در صورت لزوم می توانید توضیحاتی برای این مدرک ذکر کنید" />
											</v-col>
											<v-col cols="2" class="my-0 py-0">
												<v-btn v-if="!item.editMode" @click="edit(item)" class="ms-2" small fab dark color="secondary" title="ویراش">
													<v-icon dark>
														mdi-square-edit-outline
													</v-icon>
												</v-btn>
												<v-btn v-if="!item.editMode" @click="remove(item, index)" class="ms-2" small fab dark color="pink" title="حذف">
													<v-icon dark>
														mdi-trash-can-outline
													</v-icon>
												</v-btn>
												<v-btn :loading="submitLoading" @click="save(item, index)" class="ms-2" title="ذخیره" v-if="item.editMode" color="success" fab small dark>
													<v-icon dark>
														mdi-check
													</v-icon>
												</v-btn>
												<v-btn class="ms-2" @click="cancel(item, index)" v-if="item.editMode" title="انصراف" color="grey" fab small dark>
													<v-icon dark>
														mdi-close
													</v-icon>
												</v-btn>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-card>
							<div class="text-center mt-2" v-if="filter === 'all'">
								<v-btn class="mx-auto" color="secondary" dark @click="add">
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									تعریف مدرک جدید
								</v-btn>
							</div>
						</div>
					</div>

				</div>
			</v-container>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-spacer />
			<v-btn color="blue" dark :v-if="items.length" @click="emitSelectedItems">
				تایید آیتم های انتخاب شده
			</v-btn>
			<v-spacer />
		</v-card-actions>

		<confirm-dlg ref="confirm" />

		<v-dialog v-model="showManualTagDialog" max-width="500">
			<v-card>
				<v-card-title>
					<span class="headline">تگ دستی جدید</span>
				</v-card-title>
				<v-card-text>
					<v-form lazy-validation ref="manualTagForm">
						<v-text-field label="عنوان خود را وارد کنید" v-model="manualTag" :rules="[v => !!v || 'عنوان نباید خالی باشد']"></v-text-field>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text small @click="showManualTagDialog = false">بستن</v-btn>
					<v-btn color="primary" small @click="appendManualTag">درج</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-card>

</template>

<script>
import api from '@/util/app-api'
import { emptyId } from '@/util/emptyId'
import { authorizationSystemTypes } from '@/util/enums'
import toast from '@/util/toast'
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document'

export default {
	name: 'AuthorizationItems',
	props: {
		data: { type: Object },
		loan: { type: Object },
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
	},
	data() {
		return {
			selectedIndex: 0,
			showManualTagDialog: false,
			manualTag: '',
			emptyId: emptyId,
			selectedItems: [],
			errorMessages: '',
			items: [],
			selectedItemIds: [],
			localData: {},
			submitLoading: false,
			loading: false,
			systemTypes: authorizationSystemTypes,
			filter: 'all',
			editor: ClassicEditor,
			editorInstances: {},
			editorConfig: {
				contentsLangDirection: 'rtl',
				language: 'fa',
				toolbar: {
					shouldNotGroupWhenFull: true
				}
			},
		}
	},
	computed: {
		filteredItems() {
			if (this.filter === 'all')
				return this.items

			if (!this.loan)
				return this.items

			return this.items.filter(x => (this.loan.loanAuthorizationItems || []).findIndex(a => a.authorizationItem.id === x.id) > -1 || (this.loan.agentLoanAuthorizationItems || []).findIndex(a => a.authorizationItem.id === x.id) > -1)
		}
	},
	mounted() {
		if (this.loan)
			this.filter = 'loan'
		this.loadData()
	},
	methods: {
		patternTags(systemType) {
			switch (systemType) {
				case 5:
					return ['{نام مشتری}', '{نام پدر مشتری}', '{کد ملی مشتری}', '{آدرس مشتری}', '{شماره موبایل مشتری}', '{شماره حساب مشتری}', '{نام بانک مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{کد نماینده}', '{آدرس نماینده}', '{شماره درخواست وام}', '{نام طرح وام}', '{مبلغ وام}', '{تعداد اقساط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{تاریخ امروز}', '{نام و نام خانوادگی ضامن اول}', '{کد ملی ضامن اول}', '{موبایل ضامن اول}', '{نام و نام خانوادگی ضامن دوم}', '{کد ملی ضامن دوم}', '{موبایل ضامن دوم}', '{نام و نام خانوادگی ضامن سوم}', '{کد ملی ضامن سوم}', '{موبایل ضامن سوم}']
				case 6:
					return ['{نام مشتری}', '{نام پدر مشتری}', '{کد ملی مشتری}', '{آدرس مشتری}', '{شماره موبایل مشتری}', '{شماره حساب مشتری}', '{نام بانک مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{کد نماینده}', '{آدرس نماینده}', '{شماره درخواست وام}', '{نام طرح وام}', '{مبلغ وام}', '{تعداد اقساط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{تاریخ امروز}', '{نام و نام خانوادگی ضامن}', '{کد ملی ضامن}', '{موبایل ضامن}']
				case 7:
					return ['{نام مشتری}', '{نام پدر مشتری}', '{کد ملی مشتری}', '{آدرس مشتری}', '{کدپستی}', '{شماره موبایل مشتری}', '{شماره حساب مشتری}', '{نام بانک مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{کد نماینده}', '{آدرس نماینده}', '{شماره درخواست وام}', '{نام طرح وام}', '{مبلغ وام}', '{تعداد اقساط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{تاریخ امروز}']
				default:
					break
			}
			return []
		},
		isModuleActive(systemType) {
			if (!systemType) return true
			switch (systemType.id) {
				case 4:
					return this.checkActivePart('refahBeta')
				case 5:
				case 6:
					return this.checkActivePart('digitalSign')
				case 7:
					return this.checkActivePart('emzame')
				case 10:
					return this.checkActivePart('memberAuthorization')
				default:
					break
			}
			return true
		},
		loadData() {
			this.loading = true
			api.get('admin/AuthorizationItem/List', null)
				.then(
					response => {
						this.items = response.map(x => {
							x.editMode = false
							x.systemType = this.systemTypes.find(s => s.id == x.systemType)
							return x
						})
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.loading = false
				})
		},
		edit(item) {
			item.editMode = true
			item.original = JSON.parse(JSON.stringify(item))
		},
		save(item, index) {
			this.submitLoading = true
			var clone = { ...item }
			clone.systemType = item.systemType.id
			api.post('admin/AuthorizationItem/' + (item.id === emptyId ? 'create' : 'edit'), clone)
				.then(response => {
					toast.success('اطلاعات با موفقیت ذخیره شد.')
					item.editMode = false
					if (item.id === emptyId) {
						this.items[index].id = response
					}
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.submitLoading = false })
		},
		cancel(item, index) {
			if (item.id == emptyId) {
				this.items.splice(index, 1)
				return
			}
			item.title = item.original?.title
			item.systemType = item.original?.systemType
			item.useIfAlreadyExist = item.original?.useIfAlreadyExist
			item.description = item.original?.description
			item.editMode = false
		},
		async remove(item, index) {
			if (!item) {
				return
			}

			if (item.id == emptyId) {
				this.items.splice(index, 1)
				return
			}

			if (await this.$refs.confirm.open(
				'توجه',
				'آیا از حذف این آیتم مطمئن هستید؟',
			)) {
				api.post('admin/AuthorizationItem/delete/' + item.id)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.items.splice(index, 1)
						})
					.catch(err => {
						toast.error(err.message)
					})
			}
		},
		add() {
			let newItem = {
				id: emptyId,
				title: '',
				systemType: this.systemTypes.find(x => x.id === 0),
				useIfAlreadyExist: false,
				description: '',
				editMode: true,
			}
			this.items.push(newItem)
		},
		checkboxChanged(state, item) {
			let index = this.selectedItems.findIndex(x => x.id === item.id)
			if (!state && index > -1)
				this.selectedItems.splice(index, 1)
			if (state && index === -1) {
				var clone = { ...item }
				clone.systemType = item.systemType.id
				this.selectedItems.push(clone)
			}
			this.selectedItemIds = this.selectedItems.map(x => x.id)
		},
		emitSelectedItems() {
			if (!this.selectedItems.length) {
				toast.error('حداقل یک آیتم باید انتخاب شود.')
				return
			}
			let notSaved = this.selectedItems.find(x => x.id === emptyId)
			if (notSaved) {
				toast.error(`آیتم ${notSaved.title} ذخیره نشده است.`)
				return
			}
			this.$emit('select', this.selectedItems)
		},
		checkboxAllChanged(state) {
			if (!state) {
				this.selectedItems = []
				this.selectedItemIds = []
				return
			}
			for (let item of this.filteredItems) {
				let index = this.selectedItems.findIndex(x => x.id === item.id)
				if (!state && index > -1)
					this.selectedItems.splice(index, 1)
				if (state && index === -1) {
					var clone = { ...item }
					clone.systemType = item.systemType.id
					this.selectedItems.push(clone)
				}
			}
			this.selectedItemIds = this.selectedItems.map(x => x.id)
		},
		onEditorReady(editor, index) {
			editor.ui.getEditableElement().parentElement.insertBefore(
				editor.ui.view.toolbar.element,
				editor.ui.getEditableElement()
			)
			this.editorInstances[`ck${index}`] = editor
		},
		showManualTag(index) {
			this.selectedIndex = index
			this.manualTag = ''
			this.showManualTagDialog = true
		},
		appendTag(tag, index) {
			const editorInstance = this.editorInstances[`ck${index}`]

			if (!editorInstance) {
				console.warn("ckeditor instance not found for index", index)
				return
			}

			editorInstance.model.change(writer => {
				const insertText = writer.createText(tag)
				// درج در انتخاب فعلی (cursor)
				editorInstance.model.insertContent(insertText, editorInstance.model.document.selection)
			})

			// Focus the editor
			editorInstance.editing.view.focus()
		},
		appendManualTag() {
			if (!this.$refs.manualTagForm.validate())
				return
			this.appendTag(`{manual:"${this.manualTag}"}`, this.selectedIndex)
			this.showManualTagDialog = false
		}
	},
}
</script>
<style>
.pattern-tags {
	list-style: none;
}

.pattern-tags li {
	display: inline;
	margin: 3px;
	color: grey;
	cursor: pointer;
	transition: all 0.3s;
}

.pattern-tags li:hover {
	color: blueviolet
}
</style>
